/* Customer video reviews — portrait clips shot at handover.

   This is the fallback reel: the section asks the API first and shows the
   reviews the console has filed; only while that list is empty (or the API
   is unreachable) does this static set render. The youtubeId is the tail of
   a Shorts URL (youtube.com/shorts/<id>) — these are placeholder IDs so the
   cards render; the real clips are filed through the admin console. */

export type VideoReview = {
  id: string
  youtubeId: string
  name: string
  city: string
  /** Only the placeholder set carries one — rows from the API do not, and
      the card simply omits the chip. */
  duration?: string
}

export const VIDEO_REVIEWS: VideoReview[] = [
  {
    id: 'imran',
    youtubeId: 'dQw4w9WgXcQ',
    name: 'Imran Qureshi',
    city: 'Islamabad',
    duration: '0:42',
  },
  {
    id: 'mahnoor',
    youtubeId: 'jNQXAC9IVRw',
    name: 'Mahnoor Ali',
    city: 'Rawalpindi',
    duration: '0:38',
  },
  {
    id: 'danish',
    youtubeId: '9bZkp7q19f0',
    name: 'Danish Butt',
    city: 'Islamabad',
    duration: '0:55',
  },
  {
    id: 'rabia',
    youtubeId: 'kJQP7kiw5Fk',
    name: 'Rabia Shahid',
    city: 'Wah Cantt',
    duration: '0:47',
  },
  {
    id: 'fahad',
    youtubeId: 'fJ9rUzIMcZQ',
    name: 'Fahad Mirza',
    city: 'Peshawar',
    duration: '1:02',
  },
  {
    id: 'zainab',
    youtubeId: 'RgKAFK5djSk',
    name: 'Zainab Khan',
    city: 'Islamabad',
    duration: '0:51',
  },
]
